import { atomWithStorage } from "jotai/utils";

/**
 * Maps article JSON filename (from article-list.json) to the last seen
 * `dateModified` value for that entry. Used to detect updated article bodies
 * without forcing a full re-sync of every article.
 */
export const articleModifiedMapAtom = atomWithStorage<Record<string, string>>(
  "articleModifiedMapAtom",
  {},
  undefined,
  { getOnInit: true }
);
